import { msg } from '../messages'

const REGEX_LETTERS_AND_NUMBERS = /^[a-zA-Z0-9]*$/

export function onlyUnaccentedLettersAndNumbers(value: string) {
  if (!isValid(value)) {
    return msg('onlyLettersAndNumbers', value)
  }
}

function isValid(value: string) {
  return REGEX_LETTERS_AND_NUMBERS.test(value)
}
